import { createFileRoute } from "@tanstack/react-router";
import FundraisingDataRoom from "@/components/Fundraising/DataRoom";
import { PageHeader } from "@/components/PageHeader";

function RouteComponent() {
  return (
    <div className="min-w-0 space-y-4">
      <PageHeader title="Data Room" subtitle="DocSend links and documents shared with investors." />
      <FundraisingDataRoom />
    </div>
  );
}

export const Route = createFileRoute("/_authenticated/fundraising/dataroom/")({
  component: RouteComponent,
  staticData: { page: "fundraising" },
});
